import React, { useState } from "react";
import { Pen, Section } from "./newSectionModal";
import { colors, fonts, glyphs } from "../../../Styles";

interface NewSectionModalLvl3_Props {
  section: Section;
}

export default function NewSectionModalLvl3({section}:NewSectionModalLvl3_Props) {

  const generateTable = (section: Section) => {
    const numColumns = 2; // Vi har 2 kolonner i dette eksempel
    const rows = Math.ceil((section.pens).length / numColumns); // Beregn antal rækker

    const tableRows = []; // Her opbygger vi rækkene

    for (let i = 0; i < rows; i++) {
      const row = []; // En række
      for (let j = 0; j < numColumns; j++) {
        const index = i * numColumns + j; // Beregn korrekt indeks i arrayet
        if (index < (section.pens).length) {
          const pen = section.pens[index];
          const isDisabled = pen.penId === null;
          (console.log("pen:", pen.penId, pen.io, pen.feederOutput))
          row.push(
            <td key={pen.id} id={pen.id} style={{
              width: "300px",
              height: "30px",
              textAlign: "center",
              alignContent: "center",
              backgroundColor: colors.greyLightSecondary,
              filter: isDisabled
                ? "opacity(0)"
                : "opacity(1)",
              transition: "filter 0.3s",
              color: colors.greyDarkPrimary,
              ...fonts.paragraph,
              ...fonts.fontSize4,
              cursor: "default",
            }}>
              <div style={{width: "280px", padding: "0px 10px", display: "grid", gridTemplateColumns: "65px 80px 115px 20px", gridTemplateRows: "1fr"}}>
                <div style={{ gridArea: "1/1/2/2", display: "flex", alignItems: "center", gap: "5px", ...fonts.fontSize4, ...fonts.paragraph, color: colors.greyDarkPrimary }}>Pen: <b>{pen.penId}</b></div>
                
                <div style={{ gridArea: "1/2/2/3", display: "flex", alignItems: "center", gap: "5px", ...fonts.fontSize4, ...fonts.paragraph, color: colors.greyDarkPrimary }}>AICO IO: <b>{pen.io}</b></div>
                
                <div style={{ gridArea: "1/3/2/4", display: "flex", alignItems: "center", gap: "5px", ...fonts.fontSize4, ...fonts.paragraph, color: colors.greyDarkPrimary }}>Feeder Output: <b>{pen.feederOutput}</b></div>

                <div style={{gridArea: "1/4/2/5", display: "flex", alignItems: "center",}}><glyphs.Note fillColor={colors.greyDarkPrimary}/></div>
              </div>
            </td>
          );
        }
      }
      tableRows.push(<tr key={i}>{row}</tr>); // Tilføj rækken til tableRows
    }

    return tableRows;
  };

  return (
    <div style={{ borderRadius: "10px", overflow: "hidden", width: "fit-content" }}>
      <table style={{ borderSpacing: "10px", margin: "-10px" }}>
        <tbody>{generateTable(section)}</tbody>
      </table>
    </div>
  );
}